import { useAppState } from './state/AppState';
import { Header } from './components/Header';
import { RmPicker } from './components/RmPicker';
import { AuditList } from './components/AuditList';
import { IntakeForm } from './components/IntakeForm';
import { ClientDetail } from './components/ClientDetail';
import styles from './App.module.css';

export default function App() {
  const { state } = useAppState();

  if (state.loading) {
    return (
      <div className={styles.loading} role="status" aria-live="polite">
        Loading SENTINEL…
      </div>
    );
  }

  if (state.error) {
    return (
      <div className={styles.error} role="alert">
        <h1>Unable to start SENTINEL</h1>
        <p>{state.error}</p>
      </div>
    );
  }

  if (!state.currentRm) {
    return <RmPicker />;
  }

  return (
    <div className={styles.app}>
      <Header />
      <main className={styles.main}>
        {state.view.kind === 'list' && <AuditList />}
        {state.view.kind === 'intake' && <IntakeForm />}
        {state.view.kind === 'detail' && <ClientDetail clientId={state.view.clientId} />}
      </main>
    </div>
  );
}
